var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeardAndMcdonaldIslands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#071b65",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.3 19.4-1.12 1.05.11-1.53-1.52-.24 1.27-.86-.76-1.34 1.46.45.57-1.43.56 1.43 1.47-.45-.76 1.34 1.26.86-1.52.24.12 1.53zM22.8 4.22l-.74.68.08-1-1-.15.83-.57-.5-.87.96.3.37-.94.37.93.96-.3-.5.88.83.57-1 .15.08 1zm-3.7 5.54-.73.68.07-1-1-.15.84-.57-.5-.87.96.3.37-.94.37.93.96-.3-.5.88.83.57-1 .15.08 1zm8.32-1.85-.74.69.07-1-1-.16.84-.57-.5-.87.96.3.37-.94.37.94.96-.3-.5.87.82.57-.99.15.07 1zM22.8 20.83l-.74.68.08-1-1-.16.83-.56-.5-.88.96.3.37-.94.37.94.96-.3-.5.88.83.56-1 .16.08 1zm2.82-10.68.27.55.6.1-.44.42.1.6-.53-.28-.55.28.1-.6-.43-.43.6-.09z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.5 9.77V12h4V9.77L12.54 12H15v-1.24L11.24 8H15V4h-2.74L15 2V0h-1.44L9.5 2.98V0h-4v2.8L1.75 0H0v1.9L2.99 4H0v4h3.76L0 10.76V12h2.46z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "m0 1 4.09 3h1.36L0 0zm0 11 5.45-4v1l-4.09 3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M8.5 12h-2V7H0V5h6.5V0h2v5H15v2H8.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 11.67 10 8v1l4.1 3h.9zM15 0h-.25L9.3 4h1.37L15 .82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeardAndMcdonaldIslands);
export default __webpack_public_path__ + "static/media/heard-and-mcdonald-islands.48364a939d9417027c3b2d026f6f871b.svg";
export { ForwardRef as ReactComponent };